import React from "react";
import { Box, Typography } from "@mui/material";

interface Step {
  id: number;
  label: string;
  completed: boolean;
}

interface PropertyRegistrationStepperProps {
  currentStep: number;
  steps: Step[];
  onStepClick?: (stepId: number) => void;
}

const PropertyRegistrationStepper: React.FC<
  PropertyRegistrationStepperProps
> = ({ currentStep, steps, onStepClick }) => {
  return (
    <Box
      sx={{
        padding: "20px 24px",
        width: "100%",
        maxWidth: "min(746px, 100%)",
        margin: "0 auto",
        boxSizing: "border-box",
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          paddingBottom: "50px",
          minWidth: 0,
        }}
      >
        {steps.map((step, index) => {
          const isActive = step.id === currentStep;
          const isCompleted = step.completed;
          const isLast = index === steps.length - 1;

          return (
            <React.Fragment key={step.id}>
              {/* ステップの列（サークル + ラベル） */}
              <Box
                sx={{
                  position: "relative",
                  flexShrink: 0,
                  minWidth: 0,
                }}
              >
                {/* ステップサークル */}
                <Box
                  sx={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor:
                      isCompleted || isActive ? "#0B9DBD" : "#fff",
                    border: "2px solid #0B9DBD",
                    cursor: onStepClick ? "pointer" : "default",
                    flexShrink: 0,
                  }}
                  onClick={() => onStepClick && onStepClick(step.id)}
                >
                  <Typography
                    sx={{
                      fontFamily: '"Noto Sans JP", sans-serif',
                      fontWeight: 500,
                      fontSize: "16px",
                      color: isCompleted || isActive ? "#fff" : "#0B9DBD",
                      lineHeight: 1,
                    }}
                  >
                    {step.id}
                  </Typography>
                </Box>

                {/* ステップラベル */}
                <Typography
                  sx={{
                    fontFamily: '"Noto Sans JP", sans-serif',
                    fontWeight: 700,
                    fontSize: "16px",
                    lineHeight: 1.7,
                    color: isCompleted || isActive ? "#0B9DBD" : "#989898",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    position: "absolute",
                    top: "40px",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  {step.label}
                </Typography>
              </Box>

              {/* ステップ間の線 */}
              {!isLast && (
                <Box
                  sx={{
                    flex: 1,
                    height: "3px",
                    backgroundColor: "#0B9DBD",
                    margin: "0 4px",
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};

export default PropertyRegistrationStepper;
